<template>
  <router-view />
</template>

<script>
export default {
  name: 'Membership'
}
</script>

<style scoped>

</style>
